import React, { useEffect, useRef, useState } from 'react';

import { format } from "date-fns";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import sl from "date-fns/locale/sl";
import BiHelp from './BiHelp';
registerLocale("sl", sl);

const BiDatePicker = ({
    name,
    value,
    onChange,
    disabled,
    width,

    help,
    helpKey,
    helpMainKey,
    minDate
}) => {
    let dod = {
        width: width == null ? "135px" : ((width) + "px"),
        display: "inline-flex",
        alignItems: "center",
        position:"relative"
    }

    const [date, setDate] = useState(new Date());

    useEffect(() => {
        if (value != null) {
            var date = new Date(value);
            setDate(date);
        } else {
            setDate("");
        }
    }, [value]);

    const onDPChange = (date) => {
        setDate(date);
        if (date != null) {
            var formattedDate = format(date, "yyyy-MM-dd") + "T00:00:00";
            onChange({ target: { name: name, value: formattedDate } });
        } else {
            onChange({ target: { name: name, value: null } });
        }
    }
    const dtRef = useRef();
    return (

        <div  style={dod}>

            <DatePicker
                ref={dtRef}
                dateFormat="dd.MM.yyyy"
                className="form-control form-control-sm biDatePicker"
                name={name}
                disabled={disabled ? "disabled" : ""}
                locale="sl"
                autoComplete="off"
                selected={date}
                minDate={minDate}
                onChange={(date) => onDPChange(date)} />

            <i className="fas fa-calendar-alt"
                onClick={() => dtRef.current.setOpen(true)}
                style={{
                    position: "absolute",
                    right: ((help == true) ? "23px" : "10px"),
                    color: "#626262"
                }}
            ></i>


            {(help == true) &&
                <BiHelp helpKey={helpKey ? helpKey : name} helpMainKey={helpMainKey ? helpMainKey : null}></BiHelp>
            }
        </div>


    );
}

export default BiDatePicker;

